
import { Component, Mixins, Prop } from "vue-property-decorator";
import { VuetifyMixin, CurrentAthleteMixin } from "@/mixins";
import { mdiChevronLeft } from "@mdi/js";
import SchoolDetailProvider from "@/components/hoc/SchoolDetailProvider.vue";
import SpecificSchool from "../components/search/school/SpecificSchool.vue";
import * as Routes from "../../types/constants/web_client_user.routes";
import { Route } from "vue-router";
import FavouriteListProvider from "@/components/hoc/FavouriteListProvider.vue";
import SubscriptionInfoProvider from "@/components/hoc/SubscriptionInfoProvider.vue";
import { userStore, notificationStore, schoolStore } from "@/store";
import SchoolSearchSvg from "@/components/svg/SchoolSearchSvg.vue";
import FeatureNotAvailableDialog from "@/components/subscriptions/FeatureNotAvailableDialog.vue";
import { SubscriptionPlanModel } from '@/models/subscriptionPlan/SubscriptionPlanModel';
import { StartCheckoutParams } from 'types/interfaces';
import { AthleteLineItemMeta } from '@/models/checkoutIntent/AthleteLineItemMeta';
import { CustomerApi } from '@/api/CustomerApi';
import SubscriptionsDialog from "@/components/subscriptions/SubscriptionsDialog.vue";
import { DummySchool } from '@/models/school/schoolDummyModel';
import { SchoolFavouriteItem } from '@/models/favouriteList/SchoolFavoriteListModel';
import { UpgradeNowMixin } from '@/mixins/UpgradeNowMixin';

@Component({
	components: {
		SpecificSchool,
		SchoolDetailProvider,
		FavouriteListProvider,
		SubscriptionInfoProvider,
		SchoolSearchSvg,
		FeatureNotAvailableDialog,
		SubscriptionsDialog
	}
})
export default class SchoolDetailPage extends Mixins(VuetifyMixin, CurrentAthleteMixin, UpgradeNowMixin) {
	mdiChevronLeft = mdiChevronLeft;

	showPlansModal = false;
	getPlanLoading = false;

	DummySchool = DummySchool;
	SchoolFavouriteItem = SchoolFavouriteItem;

	@Prop({ type: String, default: null }) schoolId: string | null;
	@Prop({ type: Number, default: null }) locationId: number | null;

	get AthleteSport(): string{
		return userStore.athlete.sports[0].id
	}

	get Gender(): string{
		return userStore.athlete.gender
	}	
	get CurrentAthleteId(): string {
		return userStore.athleteId;
	}
	get AthleteSchoolRoute(): Partial<Route> {
		return {
			name: Routes.AthleteSchoolSearch,
			params: {
				...this.$route.params,
				athleteId: userStore.athleteId
			}
		};
	}

	get Loading(): boolean{
		return schoolStore.schoolsLoading;
	}

	get LocationId(): number {
		return this.locationId !== null && this.locationId !== undefined ? this.locationId : 0;
	}

	async getPlan(plan: SubscriptionPlanModel): Promise<void>{
		this.showPlansModal = false;
		this.getPlanLoading = true;
		const params: StartCheckoutParams<AthleteLineItemMeta> = {
			title: `Upgrade to ${plan.title} Plan`,
			parentId: this.CurrentAthleteId,
			products:[
				{
					productId: plan.stripeProductId,
					quantity: 1,
					meta: {
						athleteId: this.CurrentAthleteId,
					},
				}
			],
		};
		try{
			const intent = await CustomerApi.createCheckoutIntent('athlete', this.CurrentAthleteId, params);
			this.$router.push({
				name: Routes.AthleteCheckoutPage,
				params:{
					...this.$route.params,
					checkoutIntentId: intent.id
				}
			});
		}catch(e){
			console.error("Failed to purchase plan", e);
			notificationStore.pushErrorNotificationMessage("Something went wrong, please try again later");
		}finally{
			this.getPlanLoading = false;
		}
	}
}
